export default "__VITE_ASSET__DmsL8WQ7__"